<template>
  <StandardResourceService
    title="微信小程序订阅消息"
    :tab-list="tabList"
    v-model="activeTab"
  >
    <!-- 暂未开发，先隐藏
    <SubscribePlaceholder
      v-if="activeTab === 'pushRecord'"
      description="推送记录功能开发中，敬请期待"
    />
    <SubscribePlaceholder
      v-else-if="activeTab === 'subscribeRecord'"
      description="订阅记录功能开发中，敬请期待"
    />
    -->
    <SubscribeTemplateTab v-if="activeTab === 'subscribeTemplate'"/>
  </StandardResourceService>
</template>

<script>
import StandardResourceService from '@/customComponents/standard/StandardResourceService.vue'
// import SubscribePlaceholder from '@/views/subscribe/service/SubscribePlaceholder.vue'
import SubscribeTemplateTab from '@/views/subscribe/service/SubscribeTemplateTab.vue'

export default {
  name: 'Subscription',
  components: {
    StandardResourceService,
    // SubscribePlaceholder,
    SubscribeTemplateTab
  },
  data() {
    return {
      activeTab: 'subscribeTemplate',
      tabList: [
        // { label: '推送记录', key: 'pushRecord' },
        // { label: '订阅记录', key: 'subscribeRecord' },
        { label: '订阅模板', key: 'subscribeTemplate' }
      ]
    }
  }
}
</script>

<style scoped lang="less">
</style>
